import React from "react";

export default function SectionLabel({ children, className = "" }) {
  return (
    <div className={`eyebrow ${className}`}>
      <span>{children}</span>
    </div>
  );
}
